export enum QueueDetectionMethodType {
  measured,
  estimated,
  calculated,
  lengthExceeded
}



// WEBPACK FOOTER //
// ./src/app/models/enums/queuedetectionmethod.ts